var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "otp-verify-card" }, [
    _vm.original.isEmailVerified && !_vm.meta.requestChange
      ? _c("div", { staticClass: "otp-verified" }, [
          _c("span", { staticClass: "otp-verified__badge" }, [
            _c(
              "svg",
              { attrs: { viewBox: "0 0 16 16", fill: "currentColor" } },
              [
                _c("path", {
                  attrs: {
                    d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.86-8.736z",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "otp-verified__info" }, [
            _c("span", { staticClass: "otp-verified__label" }, [
              _vm._v("Email verified"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "otp-verified__value" }, [
              _vm._v(_vm._s(_vm.email)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "otp-verified__change btn-fm btn-fm-outline",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.requestChange(true)
                },
              },
            },
            [_vm._v("\n      Change\n    ")]
          ),
        ])
      : _c(
          "div",
          { staticClass: "d-flex flex-column", staticStyle: { gap: "1rem" } },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainer,
                  label: "Email Address",
                  name: "email",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  ref: "input",
                  staticClass: "form-control",
                  attrs: {
                    id: _vm.id,
                    readonly: _vm.meta.loading || _vm.meta.codeSent,
                    name: "email",
                    placeholder: " ",
                    required: "",
                    type: "email",
                  },
                  domProps: { value: _vm.email },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.sendCode.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.meta.preventResend
              ? _c("TimeCountdown", {
                  staticClass: "fm-resend-hint",
                  attrs: {
                    disabled: _vm.meta.loading,
                    from: 60,
                    "request-change-text": "Change Email",
                  },
                  on: {
                    requestChange: _vm.onRequestEmailChange,
                    resend: _vm.sendCode,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.meta.codeSent
              ? _c(
                  "FormGroup",
                  {
                    attrs: {
                      "error-container": _vm.errorContainer,
                      label: "Verification Code",
                      name: "code",
                      floating: true,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.code,
                          expression: "form.code",
                        },
                      ],
                      staticClass: "form-control otp-code-input",
                      attrs: {
                        id: _vm.codeId,
                        readonly: _vm.meta.loading,
                        name: "code",
                        required: "",
                        type: "text",
                        maxlength: "6",
                        placeholder: " ",
                        autocomplete: "one-time-code",
                      },
                      domProps: { value: _vm.form.code },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "code", $event.target.value)
                        },
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex gap-2 flex-wrap" }, [
              _vm.original.isEmailVerified
                ? _c(
                    "button",
                    {
                      staticClass: "btn-fm btn-fm-outline",
                      attrs: { disabled: _vm.meta.loading, type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.requestChange(false)
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.meta.codeSent
                ? _c(
                    "button",
                    {
                      staticClass: "ml-2 btn-fm btn-fm-primary",
                      attrs: {
                        disabled: _vm.meta.loading || !_vm.isContactChanged,
                        type: "button",
                      },
                      on: { click: _vm.sendCode },
                    },
                    [
                      _vm.meta.loading
                        ? _c("SpinKit", { attrs: { loading: true } })
                        : _c("span", [_vm._v("Send Code")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.meta.codeSent
                ? _c(
                    "button",
                    {
                      staticClass: "btn-fm btn-fm-primary",
                      attrs: { disabled: _vm.meta.loading, type: "button" },
                      on: { click: _vm.verifyCode },
                    },
                    [
                      _vm.meta.loading
                        ? _c("SpinKit", { attrs: { loading: true } })
                        : _c("span", [_vm._v("Verify Code")]),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }